import React from 'react';
import { VolumeXIcon, HomeIcon, AlertTriangleIcon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
const painPoints = [{
  icon: VolumeXIcon,
  title: 'Ladridos excesivos por ruidos',
  description: 'El estrés de no poder descansar por cada ruido del pasillo.'
}, {
  icon: HomeIcon,
  title: 'Destrozos cuando te vas',
  description: 'Llegar a casa con el miedo de ver qué rompió hoy.'
}, {
  icon: AlertTriangleIcon,
  title: 'Ansiedad extrema',
  description: 'Esa mirada de desesperación cuando ve que tomas tus llaves.'
}];
export function PainGrid() {
  return <section className="py-20 px-5 max-w-6xl mx-auto pt-[20px] pb-[20px]" data-id="element-99">
      <FadeInUp className="pt-[20px] pb-[20px]" data-id="element-100">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-slate-dark mb-16" data-id="element-101">
          ¿Tu perro vive en un estado de alerta constante?
        </h2>
      </FadeInUp>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-102">
        {painPoints.map((point, index) => <FadeInUp key={index} delay={index * 0.1} data-id="element-103">
            <div className="bg-zen-beige p-8 rounded-3xl h-full flex flex-col items-center text-center pt-[20px] pb-[20px]" data-id="element-104">
              <div className="bg-white p-4 rounded-full shadow-sm mb-6 pt-[20px] pb-[20px]" data-id="element-105">
                <point.icon className="w-8 h-8 text-slate-dark" data-id="element-106" />
              </div>
              <h3 className="text-xl font-bold text-slate-dark mb-4" data-id="element-107">
                {point.title}
              </h3>
              <p className="text-slate-dark/70 leading-relaxed" data-id="element-108">
                {point.description}
              </p>
            </div>
          </FadeInUp>)}
      </div>
    </section>;
}